const messages = {
  name: 'Provider |||| Providers',
  dialog: {
    title: 'Provider Details',
  },
  actions: {
    addProvider: 'Add Provider',
  },
  filters: {
    providerName: 'Provider Name',
    communicationType: 'Communication Type',
  },
  fields: {
    providerName: 'Provider Name',
    providerStatus: 'Provider Status',
    priority: 'Priority',
    retries: 'Retries',
    communicationType: 'Communication Type',
    uploadFile: 'Upload Push Notification File',
    pushNotificationFile: 'Push notification file',
    hostname: 'Hostname',
    port: 'Port',
    username: 'Username',
    password: 'Password',
    securityType: 'Security Type',
    from: 'From',
    serviceAccountEmail: 'Service Account Email',
    privateKey: 'Private Key',
    userToImpersonate: 'User To Impersonate',
    apiEndpoint: 'Api Endpoint',
    apiKey: 'API Key',
    apiSecret: 'Api Secret',
    apisecret: 'Api Secret',
    customHeaders: 'Custom Headers',
    senderId: 'Sender Id',
    businessPhoneNumber: 'Business Phone Number',
    botToken: 'Bot Token',
    viberAuthToken: 'Viber Auth Token',
    viberSenderName: 'Sender name',
    lineChannelAccessToken: 'Channel Access Token',
    phoneNumberId: 'Phone Number ID',
    wabaId: 'WABA ID',
    accessToken: 'Access Token',
    graphApiVersion: 'Graph API Version',
    metaBusinessPhoneNumber: 'Business Phone Number',
    whatsAppProviderType: 'WhatsApp Transport',
    webhookUrl: 'Webhook URL',
  },
  rail: {
    general: 'General',
    email: 'Email',
    messaging: 'Messaging',
    push: 'Push',
    teamChat: 'Team chat',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
  },
  email: {
    variants: {
      basicAuth: 'SMTP Via Basic Auth Provider',
      oauth2: 'SMTP Via Oauth2 Provider',
      api: 'SendGrid Api',
      none: 'None',
    },
  },
  whatsApp: {
    transport: 'WhatsApp Transport',
    transportHelper:
      'Each provider carries one transport. Create another provider to enable the other one.',
    variants: {
      twilio: 'Twilio',
      meta: 'Meta WhatsApp Cloud API',
    },
  },
  sections: {
    basicInfo: 'Basic Information',
    email: 'Email Provider',
    sms: 'SMS Provider',
    whatsApp: 'WhatsApp Provider',
    telegram: 'Telegram Provider',
    viber: 'Viber Provider',
    line: 'LINE Provider',
    push: 'Push Notification',
    teamChat: 'Team chat',
  },
  help: {
    basic: 'Core provider settings — name, status and delivery policy.',
    email: 'Configure how outbound email is delivered.',
    sms: 'Enable to configure SMS delivery.',
    whatsApp: 'Enable to configure WhatsApp delivery.',
    telegram: 'Enable to configure Telegram delivery.',
    viber: 'Enable to configure Viber bot delivery.',
    viberSenderName: 'Shown as the message sender in Viber (max 28 chars).',
    line: 'Enable to configure LINE bot delivery.',
    push: 'Enable to configure web push notifications.',
    teamChat: 'Enable to route this platform via its incoming webhook.',
    teamChatWebhook: 'Incoming-webhook URL for this platform (kept as a secret).',
    createBanner: 'Create a new provider for your Notify account.',
    editBanner: 'Update the provider configuration.',
    sensitiveOnEdit: 'Leave empty to keep the existing value.',
  },
  push: {
    existingFileNotice: 'A push notification file already exists. Toggle "Replace existing file" to upload a new one.',
    replaceToggle: 'Replace existing file',
  },
  create: {
    title: 'Create Provider',
  },
  edit: {
    title: 'Edit Provider',
  },
  delete: {
    title: 'Delete provider "%{recordName}"',
    content: 'Are you sure you want to delete this provider? This action cannot be undone.',
  },
  notifications: {
    created: 'Provider created successfully',
    updated: 'Provider updated successfully',
    deleted: 'Provider deleted successfully',
  },
  validation: {
    required: '%{field} is required',
    maxLength: '%{field} must be at most %{max} characters',
    minValue: '%{field} must be greater than or equal to %{min}',
    positive: '%{field} must be a positive number',
  },
};

export default messages;
